import React from 'react'
import ManagerRow from '../ManagerRow/ManagerRow'
import styles from './Location.module.scss'

const Location = ({
  totalBudget,
  totalDeals,
  name,
  managers,
  sortBy,
  currentDay,
  daysInPeriod,
  translate,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.containerHead}>
        <div className={styles.location}>{name}</div>
        <div className={styles.target}>
          <span className={styles.targetLabel}>{translate.target}</span>
          <span className={styles.targetSeparator} />
          <span className={styles.targetValue}>
            {sortBy === 'budget'
              ? Number(totalBudget) + '₸'
              : Number(totalDeals)}
          </span>
        </div>
      </div>
      {managers.map((manager, index) => (
        <ManagerRow
          key={index}
          {...manager}
          progress={
            sortBy === 'budget' ? manager.targetBudget : manager.targetDeals
          }
          target={sortBy === 'budget' ? manager.budget : manager.deals}
          sortedGoal={
            sortBy === 'budget'
              ? `${Number(manager.budget)}₸`
              : Number(manager.deals)
          }
          limit={
            sortBy === 'budget'
              ? (manager.budget / daysInPeriod) * currentDay
              : (manager.deals / daysInPeriod) * currentDay
          }
          targetProgress={
            sortBy === 'budget'
              ? `${manager.targetBudget}₸`
              : manager.targetDeals
          }
          index={index}
          translate={translate}
        />
      ))}
      <div className={styles.line}></div>
    </div>
  )
}

export default Location
